import axios from 'axios'

const config = { baseURL: `${process.env.SOCKET_URL}/socket/v2` }

export const getMessageHead = ({ shipmentId, orderNumber, typeMessage }) => {
  return axios.get(`/customer/message/${typeMessage}/head/${shipmentId}/${orderNumber}`, config)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getMessageBody = ({ shipmentId, orderNumber, shipmentDate, typeMessage }) => {
  return axios.get(`/customer/message/${typeMessage}/body/${shipmentId}/${orderNumber}/${shipmentDate}`, config)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getMessageHeadEmail = async ({ shipmentId, orderNumber, typeMessage }) => {
  try {
    const res = await axios.get(`/customer/message/${typeMessage}/head/email/${orderNumber}`, config)
    return res
  } catch (err) {
    console.log('err', err, err)
    throw err.response
  }
}

export const getMessageBodyEmail = async ({
  shipmentId, orderNumber, shipmentDate, typeMessage
}) => {
  let url = `/customer/message/email/${typeMessage}/body/${shipmentId}/${orderNumber}/${shipmentDate}`
  try {
    const res = await axios.get(url, config)
    return res
  } catch (err) {
    console.log('err', err, err)
    throw err.response
  }
}

export const postMessage = (payload, typeMessage) => {
  return axios.post(`/customer/message/${typeMessage}`, payload, config)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const postChannelSubscribers = (payload, typeMessage) => {
  return axios.post(`/customer/message/${typeMessage}/channelsubscribers`, payload, config)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getChannelSubscribers = ({ shipmentId, orderNumber, typeMessage }) => {
  return axios.get(`/customer/message/${typeMessage}/channelsubscribers/${shipmentId}/${orderNumber}`, config)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/chat.api.js